import React from 'react';
import { observer } from 'mobx-react';
import {
  Card, CardContent, CardHeader,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from '@gamiphy/react-i18n';
import Progress from './Progress';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
  },
}));

const ProgressCard = observer(() => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader title={t('welcomePoints.title', { defaultValue: 'Unlock your welcome points' })} />
      <CardContent>
        <Progress />
      </CardContent>
    </Card>
  );
});

export default ProgressCard;
